export const DADOS_GERAIS_REAL_TIME = Symbol('dadosGeraisRealTime')
export const DADOS_GERAIS_ANALYTICS = Symbol('dadosGeraisAnalytics')
export const SALAS = Symbol('salas')
export const INFO = Symbol('info')
export const ENQUETE = Symbol('enquete')
export const QUIZ = Symbol('quiz')
export const WORD_CLOUD = Symbol('wordCloud')
